module.exports = __webpack_public_path__ + "static/shadows-layout-do-aaba29b1251adae3c63eb989f475d056.png";